import { useMemo } from "react";
import { useScheduleTemplates } from "@api/scheduleTemplate.api";
import { ScheduleTemplateListItem } from "@common/schemas/domains/accounting/scheduleTemplate.schema";
import { filterTemplatesForBill } from "@components/accounting/schedules/billScheduleTemplates";
import { BillScheduleWiring } from "./billScheduleColumns";

export interface BillScheduleTableOptions {
    scheduleTemplates?: ScheduleTemplateListItem[];
    prioritizedScheduleTemplateId?: string;
}

/** The bill-eligible policies the Schedule cells pick from, for table meta. */
export function useBillScheduleTableOptions(
    wiring: BillScheduleWiring | undefined,
): BillScheduleTableOptions {
    const scheduleTemplatesQuery = useScheduleTemplates({
        enabled: wiring != null,
    });
    const scheduleTemplates = useMemo(
        () =>
            scheduleTemplatesQuery.data
                ? filterTemplatesForBill(scheduleTemplatesQuery.data)
                : undefined,
        [scheduleTemplatesQuery.data],
    );
    const prioritizedScheduleTemplateId = wiring?.prioritizedScheduleTemplateId;
    return useMemo(
        () => ({ scheduleTemplates, prioritizedScheduleTemplateId }),
        [scheduleTemplates, prioritizedScheduleTemplateId],
    );
}
